module.exports = __webpack_public_path__ + "static/img/protoboard_830-1.fc67183.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/protoboard_830-1.svg
// module id = a2ZB
// module chunks = 0